<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-07-08 17:03:52
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-21 16:14:01
 :class="{ 'ant-menu-item-selected': getActiveClass($route, item.path) }"
-->
<template>
  <a-layout-header class="page-header">
    <div class="logos">
      <img class="logo" :src="logo" @click="goBack" />
    </div>
    <a-menu
      theme="light"
      mode="horizontal"
      :style="{ lineHeight: '49px' }"
      :selected-keys="getCurMenuActive($route)"
    >
      <a-menu-item
        v-for="item in headerMenu"
        :key="item.meta.activeMenu"
        @click="handleClick(item)"
      >
        {{ item.meta.title }}
      </a-menu-item>
    </a-menu>

    <div class="page-header-right flex-v-c">
      <!-- <a-switch
        checked-children="浅色"
        un-checked-children="深色"
        checked-value="dark"
        un-checked-value="light"
        :checked="theme"
        @change="changeTheme"
      />
      <span class="menu-rect flex-c" @click="goBack">
        <svg-icon class="menu-icon" name="icon-visual-line" />
      </span>-->

      <!-- <AppDropList /> -->

      <span v-if="user.sysSetting" class="menu-rect flex-c" @click="toSetting">
        <div class="icon-button">
          <svg-icon class="menu-icon setting" name="icon-setup-line" />
        </div>
      </span>

      <!-- 用户信息 -->
      <UserDrop :user-info="user.userInfo" @change-pwd="changePwd" />
    </div>
  </a-layout-header>
  <FormModal
    ref="pwdChangeRef"
    title="修改密码"
    width="600px"
    :submit="submitPwdChange"
  ></FormModal>
</template>

<script lang="ts">
import { defineComponent, toRefs, watch, computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserDrop from '../UserDrop/index.vue'
import { useStore } from 'vuex'
import { FormModal } from '@/components'
import usePwdReset from '@/hook/usePwdReset'
import api from '@/api'
import { message } from 'ant-design-vue'
export default defineComponent({
  components: {
    UserDrop,
    FormModal
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    backUrl: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const store = useStore()
    const activeIndex = ref('')
    const logo = computed(() => store.state.app.systemSetting.systemLogo)

    const route = useRoute()
    const router = useRouter()
    const goBack = () => {
      router.push('/welcome')
    }
    const getCurMenuActive = (route) => {
      const { path, meta } = route
      const activePath = meta.activeMenu ? meta.activeMenu : path
      return [activePath]
    }

    const handleClick = (item) => {
      const routeItem = store.state.user.sideBarMenu[item.name].find(
        (item: any) => item.children.length > 0
      )
      const path = routeItem.children.filter((ele) => !ele.meta.openURL)[0].path
      router.push(path)
    }

    watch(
      () => route.path,
      () => {
        const routePath: string = route.path
        activeIndex.value = '/' + (routePath && routePath.split('/')[1])
      }
    )

    const toSetting = () => {
      router.push('/setting')
    }

    const user = computed(() => store.state.user)
    const headerMenu = computed(() => store.state.user.headerMenu)

    // 主题
    const theme = computed(() => store.state.app.theme)
    const changeTheme = (val: string) => {
      store.dispatch('app/setTheme', val)
    }

    const pwdChangeRef = ref(null)

    const { showPwdResetModal } = usePwdReset(pwdChangeRef)
    const changePwd = () => {
      showPwdResetModal()
    }

    const submitPwdChange = async (data) => {
      const userId = store.state.user.userInfo.userId
      const res = await api.changePwd(userId, data)
      if (res) {
        message.success('密码修改成功，请重新登陆')
        store.dispatch('user/logout', userId)
      }
    }
    return {
      submitPwdChange,
      changePwd,
      pwdChangeRef,
      activeIndex,
      goBack,
      toSetting,
      getCurMenuActive,
      logo,
      user,
      theme,
      changeTheme,
      headerMenu,
      handleClick
    }
  }
})
</script>

<style lang="less">
.page-header.ant-layout-header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  padding-left: 0;
  // background: #0e1b2e;
  color: rgba(245, 247, 250, 1);
  font-size: 16px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0px -1px 0px 0px #e9ecf2;
  border-bottom: 1px solid #f0f0f0;
  .logos {
    width: 118px;
    height: 50px;
    background-color: #164ad9;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 48px;
    img {
      width: 70px;
      height: 20px;
    }
  }
  .ant-menu-root {
    flex: 1;
  }
  .ant-menu-horizontal {
    border: none;
  }
  .page-header-right {
    height: 100%;

    .menu-rect {
      width: 32px;
      height: 32px;
      margin-right: 8px;
      cursor: pointer;

      &:hover {
        // background: #005bff;
        border-radius: 2px;
      }
    }

    .icon,
    .menu-icon {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .menu-icon {
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .logo {
    // max-width: 200px;
    max-height: 32px;
    cursor: pointer;
  }

  .ant-menu-item {
    font-size: 16px;
    a {
      font-size: 16px;
    }
  }
  .ant-menu-item:hover {
    // font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    background: #fff;
  }

  .ant-menu-item-selected {
    position: relative;
    background-color: #fff;
    // font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    a {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
    }
    &::after {
      border-bottom: 2px solid #2667ff;
    }
  }
  .ant-menu-item:hover::after {
    border-bottom: 2px solid #2667ff;
  }
  .icon-button {
    margin-left: 0;
    .svg-icon {
      color: #535557;
    }
  }
  .icon-button:active {
    .svg-icon {
      color: #fff;
    }
  }
}
</style>
